export default __webpack_public_path__ + "static/media/aquarius.f12b1df8.png";